import React, {Component} from 'react';
import ReactTyped from "react-typed";

export default class Subtitle extends Component {
    render() {
        return (
            <div id="subtitle">
                <ReactTyped
                    className={'intro-subtitle'}
                    strings={[
                        "Where minds meet machines.",
                        "Artificial General Intelligence?",
                        "Ethics first, algorithms second.",
                        "Technology as a tool, not a deity.",
                        "Knowledge is power. Democratize knowledge.",
                        "Attention is all you need – but who is 'you'?",
                        "Digital literacy is a civic duty.",
                        "Smarter systems, wiser humans.",
                        "Optimizing for well-being, not fear.",
                        "Preventing AI-related catastrophes.",
                        "Bridging laypeople and nerds."]}
                    typeSpeed={70}
                    backSpeed={10}
                    loop
                />
            </div>
        );
    }
}
